








import Vue from 'vue';
import GtLoading from '@/components/svg/GtLoading.vue';

export default Vue.extend({
  name: 'GtInit',
  components: {
    GtLoading,
  },
});
